module.exports = __webpack_public_path__ + "img/sass-thumb-1.101fc52f.png";